import React, { useState } from 'react';
import PropTypes from 'prop-types';

function AwpMultiSwitch({ ...props }) {
  const [selectedSwitch, setSelectedSwitch] = useState(props.selectedSwitch || 0); //default selected
  const onToggle = (ev) => {
    const id = ev && parseInt(ev.target.id, 10);
    props.onToggle && props.onToggle(id);
    setSelectedSwitch(id);
  };

  const noOfSwitches = props && props.texts && props.texts.length > 1 ? props.texts.length : 2;
  const switchWidth = noOfSwitches * props.eachSwitchWidth;
  const switchStyles = {
    width: `${switchWidth}rem`,
    backgroundColor: props.bgColor,
    borderWidth: props.borderWidth,
    borderColor: props.borderColor,
    height: `${props.height}rem`,
  };
  const labelWidth = `${props.eachSwitchWidth || switchWidth / noOfSwitches}`;
  const labelPercentWidth = `${Math.round((1 / noOfSwitches) * 10000.0) / 100}`;
  const switches = props.texts.map((text, index) => {
    const labelStyles = {
      width: `${labelPercentWidth}%`,
      color: props.fontColor,
      lineHeight: `${props.height}rem`,
      fontSize: props.fontSize,
      fontWeight: props.fontWeight,
      fontFamily: props.fontFamily || 'Segoe UI',
    };
    let multiSwitchBodyClass = `awp-multi-switch-body`;

    if (selectedSwitch === index) {
      multiSwitchBodyClass = `${multiSwitchBodyClass} awp-multi-switch-handle-color`;
      labelStyles.color = props.selectedFontColor;
    }
    return (
      <label key={index} id={index} className={multiSwitchBodyClass} style={labelStyles} onClick={onToggle}>
        {' '}
        {props.texts[index]}{' '}
      </label>
    );
  });

  const switchHandleStyles = {
    width: `${labelWidth}rem`,
    left: `${selectedSwitch * props.eachSwitchWidth}rem`,
    height: `${props.height * 0.8}rem`,
    lineHeight: `${props.height}rem`,
    backgroundColor: props.selectedSwitchColor,
    marginTop: `${props.height / 20}rem`,
  };

  let switchToggleClass = 'awp-multi-switch-handle awp-multi-switch-handle-move';
  return (
    <div className="awp-multi-switch-container" style={switchStyles}>
      {switches}
      <span className={switchToggleClass} style={switchHandleStyles}>
        {}
      </span>
    </div>
  );
}
AwpMultiSwitch.defaultProps = {
  texts: ['Option 1', 'Option 2'],
  selectedSwitch: 0,
  bgColor: '#fff',
  borderColor: '#adb5bd',
  borderWidth: '0.063rem',
  fontColor: '#6c757d',
  selectedFontColor: '#fff',
  selectedSwitchColor: '#0d6efd',
  eachSwitchWidth: 3.6,
  height: '1.8',
  fontSize: '68%',
  fontWeight: 'normal',
};
AwpMultiSwitch.propTypes = {
  texts: PropTypes.array.isRequired,
  selectedSwitch: PropTypes.any.isRequired,
  height: PropTypes.any.isRequired,
  eachSwitchWidth: PropTypes.any.isRequired,
  selectedSwitchColor: PropTypes.any.isRequired,
  selectedFontColor: PropTypes.any.isRequired,
  fontSize: PropTypes.any.isRequired,
  fontWeight: PropTypes.any.isRequired,
  fontColor: PropTypes.any.isRequired,
  borderColor: PropTypes.any.isRequired,
  borderWidth: PropTypes.any.isRequired,
  bgColor: PropTypes.any.isRequired,
  onToggle: PropTypes.func.isRequired,
};
export default AwpMultiSwitch;
